module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmhead"
  }, [_vm._v("Acknowledgments")]), _vm._v(" "), _c('p', {
    staticClass: "figc"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/pg4.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("First and foremost, thanks to God, my Father and Creator … and his son, Jesus, my Savior.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Many thanks to my family—Kevin, Zach, Parker, and Abby—who put up with all of the craziness (and threads!) that came along with book writing. I’m so thankful for each and every one of you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Thanks to my friends Tara Rebman, Kristin Lawson, Brianne Hanson, Mary Kolb, and Cheryl Arkison, who encouraged me and offered advice behind the scenes. Thanks for cheering me on while I sewed in a bubble in my basement. I couldn’t have done it without you!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Thanks to Mrs. Gohmann, who helped out in a pinch and offered the diversion of a walk at just the right time. I’m grateful to have such a good neighbor.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Thanks to the many friends who have shared their scraps with me over the years. (You know who you are!) My quilts are all the better because of it.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Thanks to my pattern testers and proofreaders: Tracy Westhoff, Nettie Peterson, Katherine Greaves, Cheryl Arkison, Mary Kolb, and Kristin Lawson. I appreciate your feedback more than I can say!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Many, many thanks to the readers of my blog, "), _c('i', [_vm._v("crazy mom quilts")]), _vm._v(". Without you this book would not be a reality. Thanks for your encouragement and support over the past decade.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Thanks to the wonderful staff at C&T Publishing, who made this book a reality. It is a privilege to work with you.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("And last, but certainly not least, a huge thank-you to Steffani K. Burton for doing such a wonderful job quilting several of these quilts.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16aa5158","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_acknowledgement.vue
// module id = 66
// module chunks = 0